export default __webpack_public_path__ + "img/location-city.9bf8e85c.svg";